var map = {
	"./404-icon.svg": "d849",
	"./404.svg": "2948",
	"./AffiliateOperationTypes.svg": "2ac2",
	"./AppointmentTypes.svg": "7ea0",
	"./ApprovalTypes.svg": "88e6",
	"./AttendanceTypes.svg": "267f",
	"./BloodTypes.svg": "2425",
	"./DayWorkStatus.svg": "12e5",
	"./DesktopApp.svg": "e63e",
	"./DropDownLists.svg": "d50c",
	"./Educational.svg": "75f1",
	"./EducationalCategories.svg": "f076",
	"./EducationalGroupAttendances.svg": "0729",
	"./EducationalGroupStudents.svg": "2bd8",
	"./EducationalGroupTransfers.svg": "7a48",
	"./EducationalGroups-x.svg": "d198",
	"./EducationalGroups.svg": "8b1c",
	"./EducationalJoiningApplications.svg": "bd97",
	"./EducationalScheduleTimeDetails.svg": "4985",
	"./EducationalScheduleTimes.svg": "0902",
	"./EducationalScheduleUsers.svg": "9be4",
	"./EnrollmentTypes.svg": "484a",
	"./ExamTypes.svg": "6383",
	"./Exams.svg": "6b55",
	"./FeesTypes.svg": "e4b9",
	"./FinanceStatistic.svg": "a8bf",
	"./GradingPlans.svg": "b7c4",
	"./GroupScheduleExams.svg": "f13d",
	"./Groups.svg": "6706",
	"./InterestsAndFollowUps.svg": "db2d",
	"./JoiningApplicationSubscriptions.svg": "c47c",
	"./MonitorScoreExams.svg": "59b2",
	"./PriceLists.svg": "2f08",
	"./PriceQuotationAffiliateOperations.svg": "a0b5",
	"./PriceQuotationDetails.svg": "3ada",
	"./PriceQuotationJobOrders.svg": "a6d5",
	"./PriceQuotations.svg": "910e",
	"./PriceQuotations_AcceptQuotesFormCustomer.svg": "dc76",
	"./PriceQuotations_Canceled.svg": "4c15",
	"./PriceQuotations_FinishJobOrderCustomerReceive.svg": "9cea",
	"./PriceQuotations_FinishJobOrderNotCustomerReceive.svg": "76fd",
	"./PriceQuotations_InJobOrder.svg": "6daf",
	"./PriceQuotations_RejectedQuotesFormCustomer.svg": "ab2e",
	"./PriceQuotations_WaitingForCustomerAccept.svg": "3178",
	"./PriceQuotations_WaitingForQuotes.svg": "72ab",
	"./PriceQuotations_WorkProgress.svg": "41b7",
	"./Products.svg": "2507",
	"./PropertyFieldTypes.svg": "b049",
	"./PropertyTypes.svg": "ef39",
	"./QuotationPriceHistories.svg": "4eac",
	"./RelativeRelationTypes.svg": "1aed",
	"./ReplyStatusTypes.svg": "8316",
	"./ReportTemplates.svg": "3c75",
	"./ServicesAndCountedServices.svg": "d1e2",
	"./SimpleExamModels.svg": "b746",
	"./StorageSpaces.svg": "c009",
	"./StoreItems.svg": "50e4",
	"./StudentScheduleExamTimes.svg": "febb",
	"./SubscriptionTypes.svg": "2acc",
	"./SystemStructure.svg": "1fe2",
	"./Thermometer.svg": "566c",
	"./TimeZones.svg": "0b85a",
	"./TreeView.svg": "5872",
	"./UserAppSettings.svg": "66e1",
	"./UserExperiences.svg": "cbdf",
	"./UserFamilies.svg": "0644",
	"./UserInjuries.svg": "fb6f",
	"./UserInterests.svg": "3aa8",
	"./UserLoginCodes.svg": "29a9",
	"./UserOperations.svg": "62a4",
	"./UserOtherInterests.svg": "07fa",
	"./UserPersonalCards.svg": "9697",
	"./UserQualifications.svg": "37c3",
	"./UserScientificDegrees.svg": "7155",
	"./UserSettings.svg": "6127",
	"./UserSysteamInterests.svg": "144b",
	"./UserSysteamOtherInterests.svg": "077d",
	"./UserTrainingCourses.svg": "5901",
	"./UserValidSettings.svg": "32c4",
	"./UsersPersonalData.svg": "37b24",
	"./absence-plans.svg": "63fb",
	"./accepted.svg": "d989",
	"./accountTransactions.svg": "7f6e",
	"./accounts.svg": "2596",
	"./actions-data.svg": "6f78",
	"./activation-type-actived.svg": "6c3f",
	"./activation-type-archived.svg": "dfb3",
	"./activation-type-blocked.svg": "3e02",
	"./active-substance.svg": "25e0",
	"./activites-types.svg": "10f4",
	"./activity-types.svg": "de87",
	"./add-attendance.svg": "6b56",
	"./add-departure.svg": "8836",
	"./addUser.svg": "bd85",
	"./added-services-add.svg": "3bb1",
	"./added-services.svg": "afb6",
	"./address.svg": "597a",
	"./adminsEgypt.svg": "d27e",
	"./alert-time.svg": "e097",
	"./alert.svg": "49bb",
	"./alerts.svg": "c04d",
	"./allowances-daily-plans.svg": "7e59",
	"./allowances-plans.svg": "a71c",
	"./allowances.svg": "bbc4",
	"./anatomy-types.svg": "839c",
	"./anatomy.svg": "96d3",
	"./answer.svg": "9f1c",
	"./approval.svg": "c344",
	"./approve-cancel-reservation.svg": "7a4d",
	"./approve-reservation.svg": "2bcd",
	"./archive.svg": "0076",
	"./attend-reservation.svg": "4e21",
	"./attendance.svg": "b007",
	"./balances-plans.svg": "e340",
	"./banks.svg": "75c8",
	"./bell-alert.svg": "27b9",
	"./bg-01.jpg": "33da",
	"./blood-types.svg": "1936",
	"./bodyParts.svg": "e25b",
	"./boughts.svg": "d9e9",
	"./branches.svg": "bbcf",
	"./brand-places.svg": "7c61",
	"./brand-services.svg": "3790a",
	"./brand.svg": "1035",
	"./brandUsers.svg": "44b9",
	"./buildings.svg": "95db",
	"./cancel-icon.svg": "76b1",
	"./cancel-reservation.svg": "4260",
	"./cancel.svg": "541d",
	"./cardPlans.svg": "8543",
	"./cards.svg": "2aa6",
	"./cart.svg": "dd35",
	"./category.svg": "54d0",
	"./certificateDeliver.svg": "745a",
	"./certificateExport.svg": "9de7",
	"./certificates.svg": "1e2c",
	"./chambers.svg": "a1f9",
	"./changeActivationType.svg": "99a8",
	"./changePassword.svg": "8d77",
	"./check-icon.svg": "9767",
	"./checkbox-checked.svg": "6e7e",
	"./checkbox-unchecked.svg": "a845",
	"./checkmark.svg": "f2fa",
	"./cities.svg": "acd9",
	"./citizenship.svg": "dbb2",
	"./classificationDegrees.svg": "8c85",
	"./clients.svg": "90ee",
	"./close.svg": "2930",
	"./closeGroup.svg": "2ab0",
	"./code.svg": "2186",
	"./colors.svg": "46c2",
	"./communicationTypes.svg": "d28c",
	"./complaint.svg": "7b21",
	"./complaintFollowUps.svg": "a284",
	"./complaintSectors.svg": "e038",
	"./complaintTypes.svg": "7620",
	"./complaints.svg": "dc84",
	"./countedServiceTransactions.svg": "74f3",
	"./countedServiceTypes.svg": "538e",
	"./countedServices.svg": "17c6",
	"./countries.svg": "3a4b",
	"./date.svg": "9bcd",
	"./dateAndTime.svg": "47fe",
	"./days.svg": "8ef3",
	"./debts.svg": "e837",
	"./delete-not-used-codes.svg": "b7c8",
	"./description.svg": "ec2e",
	"./details.svg": "4056",
	"./discussionComments.svg": "d9b7",
	"./discussions.svg": "1287",
	"./dislike.svg": "6367",
	"./districts.svg": "8c93",
	"./download.svg": "c482",
	"./drivingLicense.svg": "ccf6",
	"./earth.svg": "cb65",
	"./educationalGroupMedia.svg": "f5fb",
	"./educationalPeriods.svg": "004b",
	"./educationalRatings.svg": "b221",
	"./educationalStages.svg": "03eb",
	"./email.svg": "7711",
	"./employee-data-basic.svg": "b6a5",
	"./employee-data-personal.svg": "ed9b",
	"./employee-salary-setting.svg": "3345",
	"./employeePayrollSettings.svg": "c89c",
	"./employees.svg": "91d3",
	"./enter-reservation.svg": "be5d",
	"./establishment-role.svg": "9bb0",
	"./establishment.svg": "57b6",
	"./excel.svg": "75fe",
	"./expenses-types-x.svg": "ab5e",
	"./expenses.svg": "9ccb",
	"./expensesTypes.svg": "a537",
	"./eye-hide.svg": "4775",
	"./eye-show.svg": "c159",
	"./facebook.svg": "44c6",
	"./favorite-add.svg": "41ed",
	"./favorite-remove.svg": "ce56",
	"./favorite.svg": "a6c7",
	"./filter.svg": "b05f",
	"./finance.svg": "10bd",
	"./finish-reservation.svg": "9471",
	"./finish.svg": "274d",
	"./floors.svg": "4557",
	"./folder-empty.svg": "a766",
	"./folder-not-empty.svg": "7666",
	"./folder.svg": "756b",
	"./followInterests.svg": "5148",
	"./followUpSettings.svg": "285a",
	"./gender.svg": "8bcb",
	"./general-specialities.svg": "0018",
	"./generalJobs.svg": "6ee5",
	"./generateExam.svg": "2b85",
	"./geographicalDistributions.svg": "c39d",
	"./governorates.svg": "315d",
	"./habits.svg": "baf6",
	"./haha.svg": "cc2e",
	"./heartRate.svg": "0c5d",
	"./historicalPlans-x.svg": "195f",
	"./historicalPlans.svg": "b60f",
	"./holiday.svg": "22b3",
	"./home-address.svg": "e571",
	"./home-email.svg": "095a",
	"./home-phone.svg": "b2f8",
	"./homepage.svg": "8cf7",
	"./hours.svg": "19bc",
	"./illustrator-forgot-password.svg": "7695",
	"./illustrator-login.svg": "2a0f",
	"./illustrator-mission.svg": "8edca",
	"./illustrator-noData.svg": "514c",
	"./illustrator-noInternet.svg": "9623",
	"./illustrator-something-wrong.svg": "ca74",
	"./illustrator-task.svg": "c515",
	"./illustrator-vision.svg": "e791",
	"./illustrator-work-time.svg": "1590",
	"./illustrator-work.svg": "8078",
	"./info-dark.svg": "67c4",
	"./info.svg": "db39",
	"./injuryTypes.svg": "f1a9",
	"./instagram.svg": "d91d",
	"./installmentBatchTypes.svg": "0287",
	"./installmentPayments.svg": "2001",
	"./installments.svg": "b2a5",
	"./insuranceCompanies.svg": "1264",
	"./insurances-plans.svg": "84cb",
	"./insurances.svg": "5f53",
	"./interestFollowUps.svg": "fdd3",
	"./interests.svg": "9ccc",
	"./jobGrade.svg": "d778",
	"./jobs.svg": "e241",
	"./kilometer.svg": "d20a",
	"./kilometer2.svg": "4cf2",
	"./kilometer3.svg": "be8f",
	"./knownMethods.svg": "beab",
	"./lang-ar.svg": "5b39",
	"./lang-en.svg": "b888",
	"./latitude.svg": "3432",
	"./lecturers.svg": "67b4",
	"./length.svg": "7480",
	"./like.svg": "9f80",
	"./link.svg": "b434",
	"./linkedin.svg": "6a55",
	"./location-pin.svg": "a805",
	"./location.svg": "3589",
	"./logo-old.png": "c9e7",
	"./logo.png": "9d64",
	"./logout.svg": "4488",
	"./longitude.svg": "5fe3",
	"./main-columns.svg": "2c27",
	"./man.svg": "eb6f",
	"./maritalStatus.svg": "9a34",
	"./masterAdmins.svg": "0a3f",
	"./maxDiscountPercentage.svg": "b1ae",
	"./meal.svg": "9bea",
	"./meals-types.svg": "a1f5",
	"./measurement-rooms-x.svg": "1956",
	"./measurement-rooms.svg": "1f0e",
	"./media-folder.svg": "4e8a",
	"./media.svg": "0500",
	"./mediaPackageCodes.svg": "e2d7",
	"./mediaPackages.svg": "61f6",
	"./medical-operations-x.svg": "7db1",
	"./medical-operations.svg": "b8ee",
	"./medical-prescription.svg": "3066",
	"./medical-rays-x.svg": "2af3",
	"./medical-rays.svg": "c0e8",
	"./medical-tests-x.svg": "2901",
	"./medical-tests.svg": "d32f",
	"./medication-quantity.svg": "da1e",
	"./medicines-types.svg": "1467",
	"./medicines.svg": "6ec8",
	"./merge.svg": "f0dc",
	"./method-paids.svg": "0984",
	"./militaryStatus.svg": "b1d8",
	"./minutes.svg": "59e4",
	"./mode-dark.svg": "be60",
	"./mode-light.svg": "e7c3",
	"./money.svg": "095c",
	"./month-allowances-plans.svg": "1eb2",
	"./months-settings.svg": "0ce7",
	"./months.svg": "902a",
	"./movement.svg": "8d1d",
	"./nationalNumber.svg": "1f8b",
	"./news-defult-img.svg": "f16c",
	"./news.svg": "8025",
	"./newsCategories.svg": "f5fc",
	"./not-authenticated.svg": "162a",
	"./notes.svg": "bf2f",
	"./notifications.svg": "8b0c",
	"./number.svg": "80e1",
	"./offers.svg": "1541",
	"./office-time.svg": "9d23",
	"./office.svg": "8de2",
	"./official-holidays-plans.svg": "8bef",
	"./old-logo.png": "1b9c",
	"./open-folder.svg": "0085",
	"./open.svg": "b8b6",
	"./openGroup.svg": "44db",
	"./operationTypes.svg": "d892",
	"./overtime-plans.svg": "7fe3",
	"./paragraph.svg": "5e58",
	"./parents.svg": "444d",
	"./passportNumber.svg": "f6c8",
	"./passwordlock.svg": "8600",
	"./pay.svg": "46d6",
	"./paymentMethods.svg": "f6ec",
	"./payroll.svg": "da48",
	"./pc.svg": "3d0c",
	"./pdf.svg": "5fe9",
	"./pencil.svg": "68e3",
	"./percentage.svg": "4be0",
	"./personalCardTypes.svg": "542c",
	"./phone-landline.svg": "eef0",
	"./phone.svg": "cf63",
	"./photo.svg": "ad6dc",
	"./placeUsers.svg": "0cad",
	"./places.svg": "ea57",
	"./plus.svg": "5860",
	"./points-wallets.svg": "7073",
	"./points.svg": "dbc9",
	"./ppt.svg": "3175",
	"./pressure.svg": "45c0",
	"./price-offer.svg": "ac89",
	"./print.svg": "01be",
	"./priorityTypes.svg": "2994",
	"./privileges.svg": "d3d9",
	"./qr-code-enquiry.svg": "c71e",
	"./qr-code-generate.svg": "edbf",
	"./qr-code.svg": "e6cf7",
	"./qualifications.svg": "0fb7",
	"./question.svg": "fe82",
	"./questions-x.svg": "4b47",
	"./questions.svg": "3ec3",
	"./reason.svg": "465a",
	"./receipt.svg": "b7cd",
	"./refund.svg": "9d70",
	"./rejected.svg": "8c6b",
	"./relative-relation.svg": "4a7ba",
	"./religions.svg": "f5b6",
	"./reminderPlans.svg": "9d8f",
	"./reminders.svg": "e693",
	"./reply.svg": "c718",
	"./report-attend.svg": "11a4",
	"./report.svg": "3c8a",
	"./reports.svg": "c387",
	"./reportsAndStatistics.svg": "fbd7",
	"./requirement-types.svg": "d2f5",
	"./requirements.svg": "d4bc",
	"./reservations-followed-add.svg": "c6ee",
	"./reservations-followed.svg": "af53",
	"./revenues-types-x.svg": "afdd",
	"./revenues.svg": "1fad",
	"./revenuesTypes.svg": "6f6d",
	"./salary-effects.svg": "881a",
	"./salary-settings.svg": "faec",
	"./sales.svg": "7b11",
	"./scientificDegrees.svg": "d243",
	"./search-icon-x.svg": "4c97",
	"./search-icon.svg": "d702",
	"./search.svg": "22ee",
	"./seconds.svg": "8fbb",
	"./sectors.svg": "7c7d",
	"./sellCards.svg": "dc28",
	"./sellers.svg": "c148",
	"./sendToClient.svg": "63df",
	"./serialNumber.svg": "b1b1",
	"./serviceEntitlements.svg": "9059",
	"./serviceTypes.svg": "5e6d",
	"./services-defalut.svg": "fdc6",
	"./services-payments.svg": "dee9",
	"./services-reservations.svg": "9789",
	"./services.svg": "0961",
	"./settings-additional.svg": "92b4",
	"./settings-establishment.svg": "7cdb",
	"./settings-general.svg": "437d",
	"./settings-other.svg": "cbba",
	"./settings-salary.svg": "ce6f",
	"./settings.svg": "09a5",
	"./share-icon.svg": "e7f2",
	"./sharedMediaFolders.svg": "e5f2",
	"./sharedMediaWithSpaceStorageMedias.svg": "863a",
	"./sharedMedias.svg": "b4b1",
	"./sheets.svg": "ba9c",
	"./slices.svg": "b5cd",
	"./slider1.svg": "ca1a",
	"./slider2.svg": "b3f6",
	"./slider3.svg": "073f",
	"./slider4.svg": "ab8a",
	"./socialStatuses.svg": "22f9",
	"./solds.svg": "f576",
	"./sort.svg": "884a",
	"./special-spcialities.svg": "e769",
	"./specialties.svg": "ba9a",
	"./sponsers.svg": "103e",
	"./sponsors.svg": "05cc",
	"./statement.svg": "3008",
	"./statistics.svg": "2356",
	"./stores.svg": "99c9",
	"./students-x.svg": "37a8",
	"./students.svg": "cf40",
	"./subscribeInPakage.svg": "c787",
	"./suger.svg": "0999",
	"./suppliers.svg": "ea5c",
	"./symbol.svg": "e648",
	"./symptoms.svg": "8684",
	"./sync.svg": "7e44",
	"./syndrome.svg": "dc57",
	"./systemComponents.svg": "1a79",
	"./systemComponentsHierarchies.svg": "b8d4",
	"./theBrands.svg": "d931",
	"./theCards.svg": "d124",
	"./time.svg": "56de",
	"./trash.svg": "311a",
	"./treasuries-transactions.svg": "7740",
	"./treasuries.svg": "0909",
	"./treatmentPlan-x.svg": "b909",
	"./treatmentPlan.svg": "7249",
	"./treatments-reservation.svg": "7c732",
	"./treatments.svg": "6265",
	"./twitter.svg": "1538",
	"./type - Copy.svg": "9029",
	"./type.svg": "bdf5",
	"./unfinish.svg": "8edc",
	"./unshare.svg": "d89d",
	"./upload-icon.svg": "83e7",
	"./user-cancel.svg": "5baf",
	"./user-ok.svg": "a637",
	"./user.jpg": "3810",
	"./user.svg": "c9d8",
	"./users.svg": "4e3e",
	"./verification-code.svg": "b5ec",
	"./video-camera.svg": "463c",
	"./video.svg": "b5ee",
	"./view-grid.svg": "3581",
	"./view-list.svg": "79d6",
	"./voice.svg": "8ea8",
	"./waiting-back.svg": "bfa1",
	"./wallet.svg": "b23e",
	"./warning-x.svg": "7ec3",
	"./warning.svg": "e4db",
	"./week.svg": "1dd1",
	"./weight.svg": "70d6",
	"./whatsapp.svg": "e8a9",
	"./word.svg": "0f29",
	"./work-plan-days.svg": "05be",
	"./work-plans.svg": "ddb4",
	"./work-schedule.svg": "f95f",
	"./work-shifts.svg": "98b4",
	"./year-settings.svg": "9d2a",
	"./year.svg": "5f60",
	"./youtube.svg": "694f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";